import { myTopicsService } from '../../Services/MyTopicsService'
import * as actionTypes from './ActionTypes'

const setToken = (token) => ({ type: actionTypes.SET_MY_TOPICS_TOKEN, payload: { token } })
const setItems = (items) => ({ type: actionTypes.SET_MY_TOPICS, payload: { items } })

// The profile is created on the first follow, not on every visit.
const ensureProfile = () => async (dispatch, getState) => {
  const existing = getState().myTopics?.token
  if (existing) return existing

  const response = await myTopicsService.createProfile()
  if (!response.isOk) return null
  dispatch(setToken(response.data.token))
  return response.data.token
}

export const loadMyTopics = () => async (dispatch, getState) => {
  const token = getState().myTopics?.token
  if (!token) return

  const response = await myTopicsService.getMyTopics(token)
  if (response.isOk) {
    dispatch(setItems(response.data))
  } else if (response.status === 401) {
    // Profile gone (deleted on the server): start over on the next follow.
    dispatch(setToken(null))
    dispatch(setItems([]))
  }
}

/* body: { topic_id } or { keywords }. Resolves to { isOk, message }. */
export const addMyTopic = (body) => async (dispatch, getState) => {
  const token = await dispatch(ensureProfile())
  if (!token) return { isOk: false, message: 'Došlo je do greške. Pokušajte ponovo.' }

  let response = await myTopicsService.addMyTopic(token, body)
  if (response.status === 401) {
    // Stale token: make a new profile once and retry.
    dispatch(setToken(null))
    const fresh = await dispatch(ensureProfile())
    if (!fresh) return { isOk: false, message: 'Došlo je do greške. Pokušajte ponovo.' }
    response = await myTopicsService.addMyTopic(fresh, body)
  }
  await dispatch(loadMyTopics())
  // 409 = already following: fine from the user's point of view.
  return response.isOk || response.status === 409
    ? { isOk: true }
    : { isOk: false, message: response.message }
}

export const removeMyTopic = (id) => async (dispatch, getState) => {
  const token = getState().myTopics?.token
  if (!token) return
  await myTopicsService.deleteMyTopic(token, id)
  await dispatch(loadMyTopics())
}
